import axiosInstance from "./axiosInstance";
export const verifyAccountIFSC = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/verify_account`,p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
// export const withdrawDMTBalanceByBeneficiary = async (p) => {
//   try {
//     const response = await axiosInstance.post(`/api/dmt/transaction/initiate`, p);
//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         " failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };


export const withdrawDMTBalanceByBeneficiary = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/transaction/initiate`, p);
    return {
      success:response.data.success || true,
      data: response?.data,   // ✅ full response
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const withdrawDMTBalanceByBeneficiaryOtp = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/transaction/initiate/verify-otp`, p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const singleTransactionTxn = async (txnId) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/transaction/single-transaction`, {
      params: { txnId }
    });

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "success",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to fetch transaction",
      status: error.response?.status || 500,
    };
  }
};


export const fetchSettalmentsLists= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/list`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
  
};
export const fetchDMtTransactionsLists= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/transaction/list`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSettalmentAccounts= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/me`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchRemittersBen= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/remitter/search`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const frDeleteBeneficiary= async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/remitter/deletebyBeme_id`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const registerRemitterByNum= async (mobile) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/remitter/register`,mobile);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const registerRemitter= async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/beneficiary`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const verifyAccountPennyDrop= async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/penny-drop/verify`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const registerRemitterVerifryOtp= async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/dmt/remitter/verify`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchRemitterById= async (id) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/remitter/user/${id}`,);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSingleBeneficiaryAccount= async (bankId,p) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/single-bank/${bankId}`,p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
